import React from "react";
import "./styles.scss";
interface KC_ToggleProps {
  id: string;
  isChecked: boolean;
  htmlFor?: string;
  setFieldValue?: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  onToggle?: () => void;
  isInactive?: boolean;
  className?: string;
}

export default function KC_Toggle(props: KC_ToggleProps) {
  const handleToggle = () => {
    if (props.isInactive) {
      return;
    }
    if (props.setFieldValue != null) {
      props.setFieldValue(props.htmlFor || "", !props.isChecked);
    }
    if (props.onToggle != null) {
      props.onToggle();
    }
  };

  return (
    <div
      className={`kc_toggle ${props.className}`}
      onClick={handleToggle}
      id={props.id}
    >
      <input type={"checkbox"} style={{ display: "none" }} />
      {props.isChecked ? (
        <svg
          className={"checked"}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="20"
          viewBox="0 0 32 20"
          fill="none"
        >
          <path
            d="M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10C32 15.5228 27.5228 20 22 20H10C4.47715 20 0 15.5228 0 10Z"
            fill={props.isInactive ? "#909090" : "#EA357F"}
          />
          <rect x="14" y="2" width="16" height="16" rx="8" fill="white" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="20"
          viewBox="0 0 32 20"
          fill="none"
        >
          <path d="M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5H22C27.2467 0.5 31.5 4.75329 31.5 10C31.5 15.2467 27.2467 19.5 22 19.5H10C4.7533 19.5 0.5 15.2467 0.5 10Z" />
          <rect
            opacity="0.5"
            x="2"
            y="2"
            width="16"
            height="16"
            rx="8"
            fill="black"
            fillOpacity="0.8"
          />
        </svg>
      )}
    </div>
  );
}
